<template>
  <div>
    <headers />
    <mytop />
    <div class="containers menulrbox clearfix">
      <div class="menuleft">
        <el-row class="tac">
          <el-col :span="24">
            <el-menu
              :default-active="active"
              class="el-menu-vertical-demo"
              active-text-color="#FFFFFF"
            >
              <router-link tag="div" :to="{path:'/course/soncourse',query:{index:0}}">
                <el-menu-item index="0">
                  <i class="iconfont icon-wodekecheng"></i>
                  <span slot="title">我的课程</span>
                </el-menu-item>
              </router-link>

              <router-link tag="div" :to="{path:'/course/soncollection',query:{index:1}}">
                <el-menu-item index="1">
                  <i class="iconfont icon-wodeguanzhu"></i>
                  <span slot="title">收藏课程</span>
                </el-menu-item>
              </router-link>
              <router-link tag="div" :to="{path:'/course/sonlearning',query:{index:2}}">
                <el-menu-item index="2">
                  <i class="iconfont icon-xuexijilu"></i>
                  <span slot="title">学习记录</span>
                </el-menu-item>
              </router-link>
              <router-link tag="div" :to="{path:'/course/sonevaluation',query:{index:3}}">
                <el-menu-item index="3">
                  <i class="iconfont icon-wodepingjia"></i>
                  <span slot="title">我的评价</span>
                </el-menu-item>
              </router-link>
              <router-link tag="div" :to="{path:'/course/sonclass',query:{index:4}}">
                <el-menu-item index="4">
                  <i class="iconfont icon-jigou"></i>
                  <span slot="title">我的班级</span>
                </el-menu-item>
              </router-link>

            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="menuright">
        <router-view />
      </div>
    </div>

    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import mytop from "@/components/mytop.vue";
import {
  Pagination,
  Row,
  Col,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem
} from "element-ui";
export default {
  components: {
    headers,
    footers,
    mytop,
    [Pagination.name]: Pagination,
    [Row.name]: Row,
    [Col.name]: Col,
    [Menu.name]: Menu,
    [Submenu.name]: Submenu,
    [MenuItemGroup.name]: MenuItemGroup,
    [MenuItem.name]: MenuItem
  },
  data() {
    return {
      active: "0"
    };
  },
  beforeRouteUpdate(to, from, next) {
    
    if(to.query.index){
      this.active = to.query.index.toString();
    }else{
      this.active = '0'
    }
    
    next();
  },
  methods: {},
  mounted() {
    if (this.$route.query.index) {
      this.active = this.$route.query.index;
    } else {
      this.active = "0";
    }
  }
};
</script>

<style scoped>
@import "~@/assets/css/my.css";
</style>